import React from 'react'
import { Header } from '../components/Header'
import Navbar from '../components/Navbar'
import Song from '../components/Song'

function Songs() {
  return (
    <div>
        <Navbar/>
        <Header heading="Songs"/>
        <Song/>
    </div>
  )
}

export default Songs